<template>
    <div class="appAbout">
        <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide class="page num1">
                <div class="warp">
                    <img src="../../../assets/images/normal/about/about_11.png" class="title  js_add_anim" />
                    <div class="center js_add_anim componty">
                        <p>
                            投米APP是为服务国内财富管理机构和理财师而推出的一个面向客户端的可视化数字资产管理平台。
                        </p>
                        <p>
                            作为星火数科旗下平台，投米APP是辅助国内理财师进行客户管理的重要工具之一，面向国内理财师的客户，提供资产配置信息中介服务。理财师可通过星火理财师APP进行线上化客户管理，而广大客户则可通过投米APP绑定专属理财师，并直接在线上进行交易，一键下单，且可随时享受专属理财师的专业服务指导。
                        </p>
                        <p>通过多年的技术沉淀，投米APP建立了一整套前沿的数字化财富管理支持服务架构，包括：智能KYC系统、智能资产配置选择工具、智能语音客服系统等，为理财师及其客户提供资产配置信息发布、信息展示等中介服务。</p>
<!--                        <img src="../../../assets/images/normal/about/tm-logo.png" alt="" />-->
                    </div>
                    <!--  <img src="../../../assets/images/normal/about/about_13.png" class="center  js_add_anim" /> -->
                </div>
                <div class="bottomArrow js_add_anim ">
                    <img src="../../../assets/images/normal/about/1_4.png" class="content  js_add_anim" />
                </div>
                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />
                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />
            </swiper-slide>
            <swiper-slide class="page num2">
                <div class="warp">
                    <img src="../../../assets/images/normal/about/about_21.png" class="title  js_add_anim" />
                    <img src="../../../assets/images/normal/about/about_23.png" class="center  js_add_anim" />
                </div>
                <div class="bottomArrow js_add_anim ">
                    <img src="../../../assets/images/normal/about/2_4.png" class="content  js_add_anim" />
                </div>
                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />
                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />
            </swiper-slide>
            <swiper-slide class="page num3">
                <div class="warp">
                    <img src="../../../assets/images/normal/about/about_31.png" class="title  js_add_anim" />
                    <img src="../../../assets/images/normal/about/about_33.png" class="center  js_add_anim" />
                </div>
                <div class="bottomArrow js_add_anim ">
                    <img src="../../../assets/images/normal/about/3_4.png" class="content  js_add_anim" />
                </div>
                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />
                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />
            </swiper-slide>
<!--            <swiper-slide class="page num4">-->
<!--                <div class="warp">-->
<!--                    <img src="../../../assets/images/normal/about/about_41.png" class="title  js_add_anim" />-->
<!--                    <img src="../../../assets/images/normal/about/about_43.png" class="center  js_add_anim" />-->
<!--                </div>-->
<!--                <div class="bottomArrow js_add_anim ">-->
<!--                    <img src="../../../assets/images/normal/about/about_42.png" class="content  js_add_anim" />-->
<!--                </div>-->
<!--                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />-->
<!--                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />-->
<!--            </swiper-slide>-->
<!--            <swiper-slide class="page num5">-->
<!--                <div class="warp">-->
<!--                    <img src="../../../assets/images/normal/about/about_51.png" class="title  js_add_anim" />-->
<!--                    <img src="../../../assets/images/normal/about/about_53.png" class="center  js_add_anim" />-->
<!--                </div>-->
<!--                <div class="bottomArrow js_add_anim ">-->
<!--                    <img src="../../../assets/images/normal/about/about_52.png" class="content  js_add_anim" />-->
<!--                </div>-->
<!--                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />-->
<!--                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />-->
<!--            </swiper-slide>-->
<!--            <swiper-slide class="page num6">-->
<!--                <div class="warp">-->
<!--                    <img src="../../../assets/images/normal/about/about_61.png" class="title  js_add_anim" />-->
<!--                    <img src="../../../assets/images/normal/about/about_63.png" class="center  js_add_anim" />-->
<!--                </div>-->
<!--                <div class="bottomArrow js_add_anim ">-->
<!--                    <img src="../../../assets/images/normal/about/about_62.png" class="content  js_add_anim" />-->
<!--                </div>-->
<!--                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />-->
<!--                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />-->
<!--            </swiper-slide>-->
            <swiper-slide class="page num8">
                <div class="warp">
                    <img src="../../../assets/images/normal/about/about_71.png" class="title  js_add_anim" />
                    <img src="../../../assets/images/normal/about/about_73.png" class="center  js_add_anim" />
                </div>
                <div class="bottomArrow js_add_anim ">
                    <img src="../../../assets/images/normal/about/4_4.png" class="content  js_add_anim" />
                </div>
                <img src="../../../assets/images/normal/about/about_right.png" class="ball-1  js_add_anim" />
                <img src="../../../assets/images/normal/about/about_left.png" class="ball-2  js_add_anim" />
            </swiper-slide>
        </swiper>
    </div>
</template>
<script>
    import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import sensors from "sa-sdk-javascript";

    export default {
    name: "aboutUs",
    data() {
        return {
            swiperOption: {
                notNextTick: true,
                loop: false,
                height: window.innerHeight,
                initialSlide: 0,
                autoplay: false,
                preloadImages: false,
                effect: "slide",
                speed: 800,
                direction: "vertical",
                on: {
                    init: function() {
                        let activeIndexNum = this.activeIndex;
                        let activeDocument = this.slides[activeIndexNum];
                        let addAnimObj = activeDocument.querySelectorAll(".js_add_anim");
                        let addAnimObjLen = addAnimObj.length;
                        for (let i = 0; i < addAnimObjLen; i++) {
                            addAnimObj[i].classList.add("anim");
                        }
                    },
                    slideChange: function() {
                        let activeIndexNum = this.activeIndex;
                        let activeDocument = this.slides[activeIndexNum];
                        let addAnimObj = activeDocument.querySelectorAll(".js_add_anim");
                        let addAnimObjLen = addAnimObj.length;
                        let animObj = document.querySelectorAll(".anim");
                        for (let m = 0; m < animObj.length; m++) {
                            animObj[m].classList.remove("anim");
                        }
                        for (let j = 0; j < addAnimObjLen; j++) {
                            addAnimObj[j].classList.add("anim");
                        }
                    }
                }
            }
        };
    },
    components: {
        swiper,
        swiperSlide
    },
    mounted() {
        sensors.track("TMAboutUs");
    }
};
</script>
<style lang="less">
@import "../css/aboutUs.less";
.componty {
    width: 90%;
    margin: 0 auto;
    p {
        font-size: 14px;
        line-height: 25px;
        color: #999999;
        text-align: left;
        margin-bottom: 15px;
        font-family: PingFangSC-Light;
    }
    img {
        margin-top: 20px;
    }
}
</style>
